<template lang="pug">
section.settings__section
  .settings__container
    .settings__flixelPlan
      .settings__flixelPlan--header
        .settings__flixelPlan--title
          h1 Manage Subscription
            
    .publicDetails__section
      a.btn.btn--purpleLight(:href='updateUrl') Update Payment Method
      a.btn.btn--purpleLight(:href='cancelUrl') Cancel Subscription
</template>

<script>
export default {
  name: 'Manage-Subscription',
  data() {
    return {
      updateUrl: '',
      cancelUrl: '',
    };
  },
  created() {
    const manageURL = new URL(location.href);
    this.updateUrl = manageURL.searchParams.get('update');
    this.cancelUrl = manageURL.searchParams.get('cancel');
  },
};
</script>




// WEBPACK FOOTER //
// src/views/ManageSettings.vue